import React, { useState } from 'react';
import { MessageCircleIcon, BotIcon, CheckCircleIcon } from 'lucide-react';
import { AIChatModal } from '../modals/AIChatModal';
export function PharmacistChat() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  return <>
      {/* Chat Button - Updated mobile positioning */}
      <button onClick={() => setIsChatOpen(true)} className="fixed bottom-44 md:bottom-20 right-4 md:right-6 bg-gradient-to-r from-[#1E2B55] to-[#2a3a6f] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all z-40 group" aria-label="Chat with Pharmacist" data-id="element-6079" data-mp="23dvzbvs2ifi9">
        <BotIcon className="w-7 h-7" data-id="element-6080" data-mp="2h4r3wvvjaag1" />
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full animate-pulse" data-id="element-6081" data-mp="2h5slzkayvx79"></span>
        {/* Tooltip */}
        <div className="absolute left-full ml-3 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-6082" data-mp="2r36pykfpetio">
          <div className="font-medium" data-id="element-6083" data-mp="rduca66ctqoq">AI Pharmacist Chat</div>
          <div className="text-xs text-gray-300 flex items-center mt-1" data-id="element-6084" data-mp="rb7uldpr1uss">
            <CheckCircleIcon className="w-3 h-3 mr-1" data-id="element-6085" data-mp="mcwmp8j0lud7" />
            Powered by AI • 24/7
          </div>
          <div className="absolute top-1/2 -left-1 transform -translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45" data-id="element-6086" data-mp="hfmw3pjw3cns"></div>
        </div>
      </button>
      <AIChatModal isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} data-id="element-6087" data-mp="1a3sishui7bq9" />
    </>;
}